import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { documentTableData } from "../../config/tableData";
import qs from "query-string";
import LoadingOverlay from "react-loading-overlay";
import _ from "lodash";
import Loader from "../common/components/Loader";
import { getTableConfig, saveTableConfig } from "../common/actions";
import actions from "./actions";
import ReportMain from "./components/documentsMain";
import {
    addToBreadCrumpData,
    popBreadCrumpRecData,
    popBreadCrumpData,
    findPrevPathFromBreadCrumpData,
    checkPermission,
    showAlert as showAlertUtil
} from "../../config/utils";
import Form from "./components/form";
import Reportinfo from "./components/documentsInfo";
import Portal from "../common/components/Portal";
import ConfirmationModal from "../common/components/ConfirmationModal";
import { DynamicColumnModal } from "../common/DynamicColumnModal";
import { MASTER_FILTER_KEYS } from "./constants";
import { getSessionDefaultClientId } from "../../utils/dashboardSession";
import { computeTableConfig, getPinnedColumnLeftPositions } from "../../utils/tableUtils";

class Index extends Component {
    pinnedColumnsRef = {};
    tableRef = React.createRef();

    state = {
        isLoading: false,
        historyPaginationParams: this.props.reportReducer.entityParams.historyPaginationParams,
        historyParams: this.props.reportReducer.entityParams.historyParams,
        tableData: {
            keys: documentTableData.keys,
            config: this.props.reportReducer.entityParams.tableConfig || _.cloneDeep(documentTableData.config)
        },
        sortParams: {
            order: {
                "efci_versions.created_at": "desc"
            }
        },
        params: this.props.reportReducer.entityParams.params,
        reportData: [],
        alertMessage: "",
        showWildCardFilter: false,
        selectedRowId: this.props.reportReducer.entityParams.selectedRowId,
        showViewModal: false,
        permissions: { restore: checkPermission("forms", "documents", "edit") },
        paginationParams: this.props.reportReducer.entityParams.paginationParams,
        selectedDocument: null,
        infoTabsData: [
            {
                key: "maindetails",
                name: "Main Details",
                path: `/documents/reportinfo/${this.props.match.params.id}/maindetails`
            }
        ],
        logData: {
            count: "",
            data: []
        },
        tableLoading: false,
        masterFilters: this.props.reportReducer.entityParams.masterFilters,
        showHardDeleteConfirmationModal: false,
        status: "active",
        showRestoreConfirmModal: false,
        tableConfigChanged: false,
        isTableResetting: false,
        setSearchField: null,
        setHighlightSearchField: null
    };

    componentDidMount = async () => {
        if (!this.isMasterFiltered() && this.props.match.path === "/documents") {
            await this.setDefaultFilter();
        }
        await this.setTableDataConfigBasedOnProject();
        await this.refreshReportList();
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (
            this.props.match.params.id !== prevProps.match.params.id &&
            (this.props.match.params.tab === "linked-cr-recommendations" || this.props.match.params.tab === "documents")
        ) {
            this.refreshReportList();
        }
    };

    refreshReportList = async () => {
        await this.setState({ isLoading: true });
        let docParams = this.state.params;
        let updatedDocParams = this.getParamsForDocument(docParams);
        await this.props.getAllReports(updatedDocParams);

        if (
            (this.props.reportReducer.getAllReports.documents &&
                !this.props.reportReducer.getAllReports.documents.length &&
                this.props.reportReducer.getAllReports &&
                this.props.reportReducer.getAllReports.error) ||
            this.props.reportReducer.getAllReports.error
        ) {
            await this.setState({ alertMessage: this.props.reportReducer.getAllReports.error });
            this.showAlerts();
        }

        this.setState({
            tableData: {
                ...this.state.tableData,
                data: this.props.reportReducer.getAllReports.documents,
                config: this.props.reportReducer.entityParams.tableConfig || this.state.tableData.config
            },
            reportList: this.props.reportReducer.getAllReports.documents,
            paginationParams: {
                ...this.state.paginationParams,
                totalCount: this.props.reportReducer.getAllReports.count,
                totalPages: Math.ceil(this.props.reportReducer.getAllReports.count / this.state.paginationParams.perPage)
            },
            showWildCardFilter: this.state.params.filters ? true : false
        });
        await this.setState({ isLoading: false });
    };

    showAlerts = () => showAlertUtil(this.state.alertMessage);

    toggleWildCardFilter = () => {
        const { showWildCardFilter } = this.state;
        this.setState({
            showWildCardFilter: !showWildCardFilter
        });
    };

    handleGlobalSearch = async search => {
        const { params } = this.state;
        await this.setState({
            params: {
                ...params,
                offset: 0,
                search
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        await this.refreshReportList();
    };

    updateSelectedRow = async rowId => {
        await this.setState({
            selectedRowId: rowId
        });
        await this.updateEntityParams();
    };

    showViewModal = () => {
        this.setState({
            showViewModal: true
        });
    };

    handleDeleteReport = async (id, isDeleted, rowData) => {
        await this.setState({
            showConfirmModal: true,
            selectedDocument: id,
            isDeleted: rowData?.status === "deleted" ? true : (isDeleted ?? false)
        });
    };

    renderConfirmationModal = () => {
        const { showConfirmModal, isDeleted } = this.state;
        if (!showConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={"Do you want to delete this Document?"}
                        message={"This action cannot be reverted, are you sure that you need to delete this item?"}
                        onNo={() => this.setState({ showConfirmModal: false })}
                        onYes={ishardDelete => {
                            ishardDelete ? this.setState({ showHardDeleteConfirmationModal: true }) : this.deleteDocumentOnConfirm(ishardDelete);
                        }}
                        isDeleted={isDeleted}
                        isHard={checkPermission("forms", "documents", "hard_delete")}
                    />
                }
                onCancel={() => this.setState({ showConfirmModal: false })}
            />
        );
    };
    renderHardDeleteConfirmationModal = () => {
        const { showHardDeleteConfirmationModal } = this.state;
        if (!showHardDeleteConfirmationModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Are you sure you want to permanently (Hard) delete this Document?`}
                        type="cancel"
                        onNo={() => this.setState({ showHardDeleteConfirmationModal: false })}
                        onYes={() => {
                            this.setState({ showHardDeleteConfirmationModal: false });
                            this.deleteDocumentOnConfirm(true);
                        }}
                    />
                }
                onCancel={() => this.setState({ showHardDeleteConfirmationModal: false })}
            />
        );
    };

    deleteDocumentOnConfirm = async (ishardDelete = false) => {
        const { selectedDocument } = this.state;
        const {
            match: {
                params: { section = "" }
            }
        } = this.props;

        this.setState({
            showConfirmModal: false,
            isLoading: true
        });
        await this.props.deleteDocument(selectedDocument, ishardDelete ? { hard_delete: true } : {});
        if (this.props.reportReducer.deleteDocumentsResponse && this.props.reportReducer.deleteDocumentsResponse.error) {
            await this.setState({
                alertMessage: this.props.reportReducer.deleteDocumentsResponse.error,
                showConfirmModal: false,
                isRedirectionOnDelete: false,
                selectedDocument: null
            });
            this.showAlerts();
        } else {
            if (this.props.reportReducer.deleteDocumentsResponse && this.props.reportReducer.deleteDocumentsResponse.success) {
                await this.setState({
                    alertMessage: this.props.reportReducer.deleteDocumentsResponse.message
                });
                this.showAlerts();
            }
            await this.refreshReportList();
            // await this.props.getMenuItems();

            if (this.props.match.params.id && section === "reportinfo") {
                popBreadCrumpRecData();
                this.props.history.push(findPrevPathFromBreadCrumpData() || "/documents");
                // this.props.history.push(redirectionurl[2].path || "/recommendations");
            }
            this.setState({
                showConfirmModal: false,
                selectedDocument: null
            });
        }
        this.setState({
            isLoading: false
        });
    };

    showEditPage = reportId => {
        const { history } = this.props;
        this.setState({
            selectedDocument: reportId
        });
        addToBreadCrumpData({ key: "edit", name: "Edit Report", path: `/documents/edit/${reportId}` });

        history.push(`/documents/edit/${reportId}`);
        // let editUrl = this.getAddorEditDocumentUrl("", this.props.basicDetails);
        // addToBreadCrumpData({ key: "edit", name: "Edit Report", path: `/documents/edit/${reportId}${editUrl}` });
        // history.push(`/documents/edit/${reportId}${editUrl}`);
    };

    showInfoPage = documentId => {
        const { history } = this.props;
        this.setState({
            selectedDocument: documentId,
            infoTabsData: [
                {
                    key: "Document",
                    name: "Document",
                    path: `/documents/reportinfo/${documentId}/maindetails`
                }
            ]
        });
        history.push(`/documents/reportinfo/${documentId}/maindetails`);
    };

    showAddForm = regionId => {
        const { history } = this.props;
        const selectedDocument = this.props.match.params.id;
        this.setState({
            selectedDocument: null
        });
        let addUrl = this.getAddorEditDocumentUrl(selectedDocument, this.props.basicDetails);
        addToBreadCrumpData({ key: "add", name: "Add Document", path: `/documents/add${addUrl}` });
        history.push(`/documents/add${addUrl}`);
    };

    getAddorEditDocumentUrl = (currentEntity, parentData) => {
        const {
            match: {
                params: { section = "" }
            },
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        let selectedConsultancy = parentData?.consultancy?.id || "";
        let selectedClient = parentData?.client?.id || "";
        let selectedRegion = parentData?.region?.id || "";
        let selectedSite = parentData?.site?.id || "";
        let selectedProject = query.pid || parentData?.project?.id || "";
        let selectedBuilding = parentData?.building?.id || "";
        let selectedFloor = parentData?.floor?.id || "";
        switch (section) {
            case "clientinfo":
                return `?cty_id=${selectedConsultancy}&c_id=${currentEntity}`;
            case "regioninfo":
                return `?cty_id=${selectedConsultancy}&c_id=${selectedClient}&r_id=${currentEntity}&p_id=${selectedProject}`;
            case "siteinfo":
                return `?cty_id=${selectedConsultancy}&c_id=${selectedClient}&s_id=${currentEntity}&r_id=${selectedRegion}&p_id=${selectedProject}`;
            case "buildinginfo":
                return `?cty_id=${selectedConsultancy}&c_id=${selectedClient}&s_id=${selectedSite}&b_id=${currentEntity}&r_id=${selectedRegion}&p_id=${selectedProject}`;
            case "projectinfo":
                return `?cty_id=${selectedConsultancy}&c_id=${selectedClient}&p_id=${currentEntity}`;
            case "initiativeInfo":
                return `?cty_id=${selectedConsultancy}&c_id=${selectedClient}&s_id=${selectedSite}&i_id=${currentEntity}&r_id=${selectedRegion}&p_id=${selectedProject}`;
            case "recommendationsinfo":
                return `?cty_id=${selectedConsultancy}&c_id=${selectedClient}&s_id=${selectedSite}&rec_id=${currentEntity}&r_id=${selectedRegion}&p_id=${selectedProject}&b_id=${selectedBuilding}&f_id=${selectedFloor}`;
            default:
                if (currentEntity) {
                    return `?d_id=${currentEntity}`;
                } else {
                    return "";
                }
        }
    };

    handlePerPageChange = async e => {
        const { paginationParams } = this.state;
        await this.setState({
            paginationParams: {
                ...paginationParams,
                perPage: e.target.value,
                currentPage: 0
            },
            params: {
                ...this.state.params,
                offset: 0,
                limit: e.target.value
            }
        });
        await this.refreshReportList();
    };

    handlePageClick = async page => {
        const { paginationParams, params } = this.state;
        await this.setState({
            paginationParams: {
                ...paginationParams,
                currentPage: page.selected
            },
            params: {
                ...params,
                // offset: page.selected * paginationParams.perPage
                offset: page.selected + 1
            }
        });
        await this.refreshReportList();
    };
    isColunmVisibleChanged = () => {
        let flag = false;
        const {
            tableData: { keys, config },
            tableConfigChanged
        } = this.state;
        keys.forEach(key => {
            if (!_.isEqual(config[key]?.isVisible, documentTableData.config[key]?.isVisible)) {
                flag = true;
            }
        });
        return flag || tableConfigChanged;
    };

    handleGoToColumn = async gotoKey => {
        if (gotoKey) {
            this.setState({
                setSearchField: gotoKey,
                setHighlightSearchField: gotoKey
            });
        }
    };
    updateWildCardFilter = async newFilter => {
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                filters: newFilter
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        this.updateEntityParams();
        await this.refreshReportList();
    };

    updateEntityParams = async tableConfig => {
        let entityParams = {
            entity: "Reports",
            selectedEntity: this.state.selectedRegion,
            paginationParams: this.state.paginationParams,
            params: this.state.params,
            wildCardFilterParams: this.state.wildCardFilterParams,
            filterParams: this.state.filterParams,
            tableConfig: tableConfig || this.state.tableData.config,
            selectedRowId: this.state.selectedRowId,
            historyPaginationParams: this.state.historyPaginationParams,
            historyParams: this.state.historyParams,
            masterFilters: this.state.masterFilters,
            status: this.state.status
        };
        await this.props.updateReportEntityParams(entityParams);
    };

    handleHideColumn = async (tableConfig, actionType = "") => {
        this.setState({ isLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));

        let updatedKeys = this.state.tableData.keys;
        let updatedConfig = this.state.tableData.config;

        if (tableConfig === "selectAll" || tableConfig === "deselectAll") {
            updatedConfig = { ...this.state.tableData.config };
            updatedKeys.forEach(item => {
                updatedConfig[item] = {
                    ...updatedConfig[item],
                    isVisible: tableConfig === "selectAll"
                };
            });
            await this.setState({
                tableData: {
                    ...this.state.tableData,
                    config: updatedConfig
                }
            });
        } else if (typeof tableConfig === "string") {
            const keyItem = tableConfig;
            updatedConfig = {
                ...this.state.tableData.config,
                [keyItem]: {
                    ...this.state.tableData.config[keyItem],
                    isVisible: !this.state.tableData.config[keyItem].isVisible
                }
            };
            await this.setState({
                tableData: {
                    ...this.state.tableData,
                    config: updatedConfig
                }
            });
        } else if (tableConfig?.keys && tableConfig?.config) {
            const { keys, config } = tableConfig;
            updatedKeys = keys;

            Object.keys(config)
                .filter(key => !config[key]?.isVisible && config[key]?.pinned)
                .forEach(key => {
                    const { left, ...remainingStyles } = config[key]?.style || {};
                    config[key] = {
                        ...config[key],
                        pinned: false,
                        style: remainingStyles
                    };
                });

            const pinnedColumns = keys.filter(key => config[key]?.isVisible && config[key]?.pinned);
            const columnLeftValues = getPinnedColumnLeftPositions(pinnedColumns, this.pinnedColumnsRef);

            pinnedColumns.forEach(key => {
                config[key] = {
                    ...config[key],
                    style: {
                        ...config[key]?.style,
                        left: columnLeftValues[key] || "auto"
                    }
                };
            });
            updatedConfig = config;

            await this.setState({
                tableData: {
                    ...this.state.tableData,
                    keys: updatedKeys,
                    config: updatedConfig
                }
            });
        }
        await this.updateEntityParams(updatedConfig);
        if (actionType !== "temp") {
            await this.saveUserTableConfig(updatedConfig, false, updatedKeys);
        }
        this.setState({ isLoading: false });
        return true;
    };

    handleColumnPin = async keyItem => {
        const { config, keys } = this.state.tableData;
        this.setState({ isLoading: true });
        await new Promise(resolve => setTimeout(resolve, 1));
        const { left, ...remainingStyles } = config[keyItem]?.style || {};

        const updatedConfig = {
            ...config,
            [keyItem]: {
                ...config[keyItem],
                pinned: !config[keyItem]?.pinned,
                style: config[keyItem]?.pinned
                    ? remainingStyles
                    : {
                          ...remainingStyles,
                          left: config[keyItem]?.style?.left || "auto"
                      }
            }
        };

        const pinnedColumns = keys.filter(key => updatedConfig[key]?.pinned);
        const columnLeftValues = getPinnedColumnLeftPositions(pinnedColumns, this.pinnedColumnsRef);

        pinnedColumns.forEach(key => {
            updatedConfig[key] = {
                ...updatedConfig[key],
                style: {
                    ...config[key]?.style,
                    left: columnLeftValues[key] || "auto"
                }
            };
        });
        this.setState({
            tableData: {
                ...this.state.tableData,
                config: updatedConfig
            },
            tableConfigChanged: true,
            isLoading: false
        });
        await this.saveUserTableConfig(updatedConfig);
        this.updateEntityParams(updatedConfig);
    };

    getListForCommonFilter = async params => {
        const { search, filters, list } = this.state.params;
        const { masterFilters } = this.state;
        params.search = search;
        params.filters = filters;
        params = { ...params, ...masterFilters };
        params.list = list ? Object.fromEntries(Object.entries(list)?.filter(([key, value]) => key !== params?.field)) : null;
        let commonFilterParams = this.getParamsForDocument(params);
        await this.props.getListForCommonFilter(commonFilterParams);
        return (this.props.reportReducer.getListForCommonFilterResponse && this.props.reportReducer.getListForCommonFilterResponse.list) || [];
    };

    getParamsForDocument = params => {
        const {
            match: {
                params: { section }
            }
        } = this.props;
        const updatedParams = {
            ...params,
            ...(this.state?.status === "active" && { active: true }),
            ...(this.state?.status === "deleted" && { deleted: true })
        };
        switch (section) {
            case "clientinfo":
                return { ...updatedParams, client_id: this.props.clientId };
            case "regioninfo":
                return { ...updatedParams, region_id: this.props.regionId };
            case "siteinfo":
                return { ...updatedParams, site_id: this.props.siteId };
            case "buildinginfo":
                return { ...updatedParams, building_id: this.props.buildingId };
            case "projectinfo":
                return { ...updatedParams, project_id: this.props.projectId };
            case "initiativeInfo":
                return { ...updatedParams, initiative_id: this.props.initiativeId };
            case "recommendationsinfo":
                return { ...updatedParams, recommendation_id: this.props.recommendationId };
            default:
                return { ...updatedParams };
        }
    };

    updateCommonFilter = async commonFilters => {
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                list: commonFilters
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        this.updateEntityParams();
        await this.refreshReportList();
    };

    resetAllFilters = async () => {
        await this.setState({
            selectedRegion: null,
            paginationParams: {
                totalPages: 0,
                perPage: 100,
                currentPage: 0,
                totalCount: 0
            },
            params: {
                ...this.state.params,
                limit: 100,
                offset: 0,
                search: "",
                project_id: null,
                filters: null,
                list: null
            },
            wildCardFilterParams: {},
            filterParams: {},
            selectedRowId: null,
            status: "active"
        });
        this.updateEntityParams();
        await this.refreshReportList();
    };

    updateTableSortFilters = async searchKey => {
        if (this.state.params.order) {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: {
                        ...this.state.params.order,
                        [searchKey]: this.state.params.order[searchKey] === "desc" ? "asc" : "desc"
                    }
                }
            });
        } else {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: { [searchKey]: "asc" }
                }
            });
        }
        this.updateEntityParams();
        await this.refreshReportList();
    };

    resetSort = async () => {
        await this.setState({
            params: {
                ...this.state.params,
                order: null
            }
        });
        this.updateEntityParams();
        await this.refreshReportList();
    };
    resetAll = async () => {
        await this.setState({
            selectedRegion: null,
            paginationParams: {
                totalPages: 0,
                perPage: 100,
                currentPage: 0,
                totalCount: 0
            },
            params: {
                ...this.state.params,
                limit: 100,
                offset: 0,
                search: "",
                project_id: null,
                filters: null,

                order: null,
                list: null
            },
            tableData: {
                ...this.state.tableData
            },

            wildCardFilterParams: {},
            filterParams: {},
            selectedRowId: null,
            status: "active"
        });
        this.updateEntityParams();
        await this.refreshReportList();
    };
    exportTableXl = async () => {
        let exportParams = {
            search: this.state.params.search,
            filters: this.state.params.filters,
            list: this.state.params.list,
            order: this.state.params.order,
            ...this.state.masterFilters
        };
        let updatedExportParams = this.getParamsForDocument(exportParams);
        await this.setState({ tableLoading: true });
        await this.props.exportDocuments({
            ...updatedExportParams
        });
        await this.setState({ tableLoading: false });
    };

    handleUpdateDocument = async (data, documentChanged) => {
        const { history } = this.props;
        this.setState({
            isLoading: true
        });
        await this.props.updateDocument(this.props.match.params.id, data, documentChanged);
        if (this.props.reportReducer.updateDocumentsResponse && !this.props.reportReducer.updateDocumentsResponse.success) {
            await this.setState({
                alertMessage:
                    this.props.reportReducer.updateDocumentsResponse.message ??
                    this.props.reportReducer.updateDocumentsResponse.error
            });
            // popBreadCrumpData();
            // history.push(findPrevPathFromBreadCrumpData() || "/documents");
            this.showAlerts();
        } else {
            if (this.props.reportReducer.updateDocumentsResponse && this.props.reportReducer.updateDocumentsResponse.success) {
                await this.setState({
                    alertMessage: this.props.reportReducer.updateDocumentsResponse.message
                });
                this.showAlerts();
            }
            await this.refreshReportList();
            popBreadCrumpData();
            history.push(findPrevPathFromBreadCrumpData() || "/documents");
        }
        this.setState({
            isLoading: false
        });
    };

    handleAddDocument = async data => {
        const { history } = this.props;
        this.setState({
            isLoading: true
        });
        await this.props.addDocument(data);
        if (this.props.reportReducer.addDocumentsResponse && !this.props.reportReducer.addDocumentsResponse.success) {
            await this.setState({
                alertMessage:
                    this.props.reportReducer.addDocumentsResponse.message ??
                    this.props.reportReducer.addDocumentsResponse.error
            });
            // popBreadCrumpData();
            // history.push(findPrevPathFromBreadCrumpData() || "/documents");
            this.showAlerts();
        } else {
            if (this.props.reportReducer.addDocumentsResponse && this.props.reportReducer.addDocumentsResponse.success) {
                await this.setState({
                    alertMessage: this.props.reportReducer.addDocumentsResponse.message ?? ""
                });
                this.showAlerts();
            }
            popBreadCrumpData();
            await this.refreshReportList();
            history.push(findPrevPathFromBreadCrumpData() || "/documents");
        }
        this.setState({
            isLoading: false
        });
    };

    getDataById = async documentId => {
        // --------------avoid loader while edit cancel -------------
        const {
            match: {
                params: { section }
            }
        } = this.props;

        if (section === "edit") {
            this.setState({
                isLoading: true
            });
        }
        //    -------------------------------------
        // this.setState({
        //     isLoading: true
        // })
        await this.props.getDocumentById(documentId);
        this.setState({
            isLoading: false
        });

        return this.props.reportReducer.getDocumentsByIdResponse;
    };

    openDeleteBox = (isDeleted = false) => {
        this.setState({
            showConfirmModal: true,
            isRedirectionOnDelete: true,
            isDeleted: isDeleted
        });
    };
    openRestoreBox = () => {
        this.setState({
            showRestoreConfirmModal: true,
            isRedirectionOnDelete: true
        });
    };

    getLogData = async reportId => {
        const { historyParams } = this.state;
        await this.props.getAllDocumentLogs(reportId, historyParams);
        const {
            reportReducer: {
                getAllDocumentsLogsResponse: { logs, count }
            }
        } = this.props;
        if (this.props.reportReducer.getAllDocumentsLogsResponse && this.props.reportReducer.getAllDocumentsLogsResponse.error) {
            await this.setState({ alertMessage: this.props.reportReducer.getAllDocumentsLogsResponse.error });
            this.showAlerts();
        } else {
            await this.setState({
                logData: {
                    ...this.state.logData,
                    data: logs
                },
                historyPaginationParams: {
                    ...this.state.historyPaginationParams,
                    totalCount: count,
                    totalPages: this.state.historyPaginationParams && Math.ceil(count / this.state.historyPaginationParams.perPage)
                }
            });
        }
    };

    handlePerPageChangeHistory = async e => {
        const { historyPaginationParams } = this.state;
        await this.setState({
            historyPaginationParams: {
                ...historyPaginationParams,
                perPage: e.target.value,
                currentPage: 0
            },
            historyParams: {
                ...this.state.historyParams,
                offset: 0,
                limit: e.target.value
            }
        });
        await this.getLogData(this.props.match.params.id);
    };

    handlePageClickHistory = async page => {
        const { historyPaginationParams, historyParams } = this.state;
        await this.setState({
            historyPaginationParams: {
                ...historyPaginationParams,
                currentPage: page.selected
            },
            historyParams: {
                ...historyParams,
                // offset: page.selected + 1
                offset: page.selected + historyPaginationParams.perPage
            }
        });
        await this.getLogData(this.props.match.params.id);
    };
    handleGlobalSearchHistory = async search => {
        const { historyParams, historyPaginationParams } = this.state;
        await this.setState({
            historyParams: {
                ...historyParams,
                offset: 0,
                search
            },
            historyPaginationParams: {
                ...historyPaginationParams,
                currentPage: 0
            }
        });
        await this.getLogData(this.props.match.params.id);
    };

    handleDeleteLog = async (id, choice = "delete") => {
        await this.setState({
            showConfirmModalLog: true,
            selectedLog: id,
            isRestoreOrDelete: choice
        });
    };

    renderConfirmationModalLog = () => {
        const { showConfirmModalLog, isRestoreOrDelete } = this.state;
        if (!showConfirmModalLog) return null;
        if (isRestoreOrDelete === "delete") {
            return (
                <Portal
                    body={
                        <ConfirmationModal
                            heading={"Do you want to delete this log?"}
                            message={"This action cannot be reverted, are you sure that you need to delete this item?"}
                            onNo={() => this.setState({ showConfirmModalLog: false })}
                            onYes={this.deleteLogOnConfirm}
                        />
                    }
                    onCancel={() => this.setState({ showConfirmModalLog: false })}
                />
            );
        } else {
            return (
                <Portal
                    body={
                        <ConfirmationModal
                            heading={"Do you want to restore this log?"}
                            message={"This action cannot be reverted, are you sure that you need to restore this item?"}
                            onNo={() => this.setState({ showConfirmModalLog: false })}
                            onYes={this.restoreLogOnConfirm}
                            isRestore={true}
                            type={"restore"}
                        />
                    }
                    onCancel={() => this.setState({ showConfirmModalLog: false })}
                />
            );
        }
    };

    deleteLogOnConfirm = async () => {
        const { selectedLog } = this.state;
        await this.props.deleteDocumentLog(selectedLog);
        if (this.props.reportReducer.deleteDocumentsLogResponse && this.props.reportReducer.deleteDocumentsLogResponse.error) {
            await this.setState({ alertMessage: this.props.reportReducer.deleteDocumentsLogResponse.error });
            this.showAlerts();
        }
        await this.getLogData(this.props.match.params.id);
        // await this.props.getMenuItems();
        this.setState({
            showConfirmModalLog: false,
            selectedLog: null
        });
    };

    HandleRestoreRegionLog = async id => {
        await this.props.restoreDocumentLog(id);
        if (this.props.reportReducer.restoreDocumentsLogResponse && this.props.reportReducer.restoreDocumentsLogResponse.error) {
            await this.setState({ alertMessage: this.props.reportReducer.restoreDocumentsLogResponse.error });
            this.showAlerts();
        }
        await this.refreshReportList();
    };

    updateLogSortFilters = async searchKey => {
        if (this.state.historyParams.order) {
            await this.setState({
                historyParams: {
                    ...this.state.historyParams,
                    order: {
                        ...this.state.historyParams.order,
                        [searchKey]: this.state.historyParams.order[searchKey] === "desc" ? "asc" : "desc"
                    }
                }
            });
        } else {
            await this.setState({
                historyParams: {
                    ...this.state.historyParams,
                    order: { [searchKey]: "asc" }
                }
            });
        }
        this.updateEntityParams();
        await this.getLogData(this.props.match.params.id);
    };

    renderConfirmationModalLog = () => {
        const { showConfirmModalLog, isRestoreOrDelete } = this.state;
        if (!showConfirmModalLog) return null;
        if (isRestoreOrDelete === "delete") {
            return (
                <Portal
                    body={
                        <ConfirmationModal
                            heading={"Do you want to delete this log?"}
                            message={"This action cannot be reverted, are you sure that you need to delete this item?"}
                            onNo={() => this.setState({ showConfirmModalLog: false })}
                            onYes={this.deleteLogOnConfirm}
                        />
                    }
                    onCancel={() => this.setState({ showConfirmModalLog: false })}
                />
            );
        } else {
            return (
                <Portal
                    body={
                        <ConfirmationModal
                            heading={"Do you want to restore this log?"}
                            message={"This action cannot be reverted, are you sure that you need to restore this item?"}
                            onNo={() => this.setState({ showConfirmModalLog: false })}
                            onYes={this.restoreLogOnConfirm}
                            isRestore={true}
                            type={"restore"}
                        />
                    }
                    onCancel={() => this.setState({ showConfirmModalLog: false })}
                />
            );
        }
    };

    deleteLogOnConfirm = async () => {
        const { selectedLog } = this.state;
        await this.props.deleteDocumentLog(selectedLog);
        if (this.props.reportReducer.deleteDocumentsLogResponse && this.props.reportReducer.deleteDocumentsLogResponse.error) {
            await this.setState({ alertMessage: this.props.reportReducer.deleteDocumentsLogResponse.error });
            this.showAlerts();
        }
        await this.getLogData(this.props.match.params.id);
        // await this.props.getMenuItems();
        this.setState({
            showConfirmModalLog: false,
            selectedLog: null
        });
    };

    HandleRestoreReportLog = async id => {
        await this.props.restoreDocumentLog(id);
        if (this.props.reportReducer.restoreDocumentLog && this.props.reportReducer.restoreDocumentLog.error) {
            await this.setState({ alertMessage: this.props.reportReducer.restoreDocumentLog.error });
            this.showAlerts();
        }
        await this.refreshReportList();
    };

    setDefaultFilter = async () => {
        await this.props.getMasterFilterLists("clients");
        const defaultClient = getSessionDefaultClientId() || this.props.reportReducer.masterFilterList?.defaultClient;
        if (defaultClient) {
            await this.setState({
                params: {
                    ...this.state.params,
                    client_ids: [defaultClient]
                },
                masterFilters: { ...this.state.masterFilters, client_ids: [defaultClient] }
            });
        }
    };

    getDocumentTableConfigParams = () => {
        const {
            location: { search }
        } = this.props;
        const query = qs.parse(search);
        const project_id = this.props.projectId || query?.pid || query?.p_id || null;
        const client_id = this.props.clientId || this.state.masterFilters?.client_ids?.[0] || null;

        return { client_id, project_id };
    };

    saveUserTableConfig = async (config, isReset, keys) => {
        const { client_id, project_id } = this.getDocumentTableConfigParams();
        await saveTableConfig({
            user_id: localStorage.getItem("userId"),
            project_id,
            client_id,
            table_type: "DOCUMENTS",
            table_settings: isReset ? null : { keys: keys || this.state.tableData.keys, config: config || this.state.tableData.config }
        });
        this.setState({ tableConfigChanged: isReset ? false : true });
    };

    setTableDataConfigBasedOnProject = async () => {
        const { client_id, project_id } = this.getDocumentTableConfigParams();
        const tableSettings =
            (
                await getTableConfig({
                    user_id: localStorage.getItem("userId"),
                    project_id,
                    client_id,
                    table_type: "DOCUMENTS"
                })
            )?.data?.table_settings || null;
        const { config: computedConfig, keys: computedKeys } = computeTableConfig({
            defaultConfig: documentTableData?.config,
            defaultKeys: documentTableData?.keys || [],
            tableSettings
        });
        await this.setState({
            tableData: {
                ...this.state.tableData,
                keys: computedKeys,
                config: computedConfig
            },
            tableConfigChanged: !!tableSettings
        });
        await this.updateEntityParams(computedConfig);
    };

    resetAllTableConfig = async () => {
        this.setState({ isTableResetting: true, isLoading: true });
        await this.saveUserTableConfig(null, true);
        await this.setTableDataConfigBasedOnProject();
        await this.refreshReportList();
        this.setState({ isTableResetting: false, isLoading: false });
    };

    updateColumnWidthInConfig = (columnKey, style) => {
        const { keys, config } = this.state.tableData;

        const pinnedColumns = keys.filter(key => config[key]?.isVisible && config[key]?.pinned);
        const columnLeftValues = getPinnedColumnLeftPositions(pinnedColumns, this.pinnedColumnsRef);

        pinnedColumns.forEach(key => {
            config[key] = {
                ...config[key],
                style: {
                    ...config[key]?.style,
                    left: columnLeftValues[key] || "auto"
                }
            };
        });

        const updatedConfig = {
            ...config,
            [columnKey]: {
                ...config[columnKey],
                style: {
                    ...config[columnKey]?.style,
                    ...style
                }
            }
        };
        this.setState({
            tableData: {
                ...this.state.tableData,
                config: updatedConfig
            }
        });
        this.saveUserTableConfig(updatedConfig);
        this.updateEntityParams(updatedConfig);
    };

    isMasterFiltered = () => {
        let flag = false;
        MASTER_FILTER_KEYS.forEach(item => {
            if (this.state.params[item.paramKey]?.length) {
                flag = true;
                return;
            }
        });
        return flag;
    };

    updateMasterFilters = masterFilters => {
        this.setState(
            {
                params: {
                    ...this.state.params,
                    ...masterFilters,
                    offset: 1
                },
                paginationParams: {
                    ...this.state.paginationParams,
                    currentPage: 0
                },
                masterFilters
            },
            () => {
                this.updateEntityParams();
                this.refreshReportList();
            }
        );
    };
    updateStatus = async status => {
        await this.setState({
            status: status,
            params: {
                ...this.state.params,
                offset: 1
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        await this.updateEntityParams();
        await this.refreshReportList();
    };
    showRestoreModal = async id => {
        await this.setState({
            showRestoreConfirmModal: true,
            selectedDocument: id
        });
    };
    restoreDocumentOnConfirm = async () => {
        const { selectedDocument } = this.state;
        this.setState({
            isLoading: true,
            showRestoreConfirmModal: false
        });
        await this.props.getRestoreDocument(selectedDocument);
        if (this.props.reportReducer.recoverDocumentResponse && this.props.reportReducer.recoverDocumentResponse?.error) {
            await this.setState({
                alertMessage: this.props.reportReducer.recoverDocumentResponse.error,
                showRestoreConfirmModal: false
            });
            this.showAlerts();
        } else {
            await this.refreshReportList();
            this.setState(
                {
                    alertMessage: this.props.reportReducer.recoverDocumentResponse?.message
                },
                () => this.showAlerts()
            );
            this.setState({
                showRestoreConfirmModal: false
            });
        }
        this.setState({
            isLoading: false
        });
    };
    renderRestoreConfirmationModal = () => {
        const { showRestoreConfirmModal } = this.state;
        if (!showRestoreConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Do you want to restore this Document?`}
                        message={""}
                        onNo={() => this.setState({ showRestoreConfirmModal: false })}
                        onYes={this.restoreDocumentOnConfirm}
                        type={"restore"}
                        isRestore={true}
                    />
                }
                onCancel={() => this.setState({ showRestoreConfirmModal: false })}
            />
        );
    };
    updateLastSortFilter = async (searchKey, val) => {
        if (this.state.params.order && this.state.params?.order?.[searchKey]) {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: {
                        [searchKey]: this.state.params.order?.[searchKey] === "asc" ? "desc" : "asc"
                    }
                }
            });
        } else {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: { [searchKey]: "desc" }
                }
            });
        }
        this.updateEntityParams();
        await this.refreshReportList();
    };

    render() {
        const {
            tableData,
            showWildCardFilter,
            paginationParams,
            selectedRowId,
            permissions,
            selectedDocument,
            infoTabsData,
            logData,
            historyPaginationParams,
            showViewModal,
            historyParams,
            masterFilters
        } = this.state;
        const {
            match: {
                params: { section },
                path
            },
            reportReducer: { masterFilterList }
        } = this.props;
        return (
            <LoadingOverlay active={this.state.isLoading} spinner={<Loader />} fadeSpeed={10}>
                {section === "add" || section === "edit" ? (
                    <Form
                        key={(this.props.match.params.id || "add") + this.props.location.search}
                        selectedDocument={selectedDocument}
                        handleAddDocument={this.handleAddDocument}
                        handleUpdateDocument={this.handleUpdateDocument}
                        getDataById={this.getDataById}
                    />
                ) : section === "reportinfo" ? (
                    <Reportinfo
                        keys={tableData.keys}
                        config={tableData.config}
                        infoTabsData={infoTabsData}
                        getDataById={this.getDataById}
                        handleUpdateData={this.handleUpdateDocument}
                        showInfoPage={this.showInfoPage}
                        showRestoreBox={this.openRestoreBox}
                        getAllSettingsLogs={this.getLogData}
                        handlePerPageChangeHistory={this.handlePerPageChangeHistory}
                        handlePageClickHistory={this.handlePageClickHistory}
                        handleGlobalSearchHistory={this.handleGlobalSearchHistory}
                        globalSearchKeyHistory={this.state.historyParams && this.state.historyParams.search ? this.state.historyParams.search : ""}
                        logData={logData}
                        handleDeleteLog={this.handleDeleteLog}
                        historyPaginationParams={historyPaginationParams}
                        handleRestoreLog={this.HandleRestoreRegionLog}
                        historyParams={historyParams}
                        updateLogSortFilters={this.updateLogSortFilters}
                        handleDeleteReport={this.handleDeleteReport}
                        showEditPage={this.showEditPage}
                        // permissions={permissions}
                        // logPermission={logPermission}
                        hasEdit={checkPermission("forms", "documents", "edit")}
                        hasDelete={checkPermission("forms", "documents", "delete")}
                        hasLogView={checkPermission("logs", "documents", "view")}
                        hasLogDelete={checkPermission("logs", "documents", "delete")}
                        hasLogRestore={checkPermission("logs", "documents", "restore")}
                        hasInfoPage={checkPermission("forms", "documents", "view")}
                        entity="documents"
                    />
                ) : (
                    <ReportMain
                        tableData={tableData}
                        showWildCardFilter={showWildCardFilter}
                        paginationParams={paginationParams}
                        handleGlobalSearch={this.handleGlobalSearch}
                        globalSearchKey={this.state.params.search}
                        updateSelectedRow={this.updateSelectedRow}
                        selectedRowId={selectedRowId}
                        isColunmVisibleChanged={this.isColunmVisibleChanged}
                        toggleWildCardFilter={this.toggleWildCardFilter}
                        showViewModal={this.showViewModal}
                        handleDeleteReport={this.handleDeleteReport}
                        showEditPage={this.showEditPage}
                        showInfoPage={this.showInfoPage}
                        showAddForm={this.showAddForm}
                        handlePerPageChange={this.handlePerPageChange}
                        handlePageClick={this.handlePageClick}
                        updateWildCardFilter={this.updateWildCardFilter}
                        wildCardFilter={this.state.params.filters}
                        handleHideColumn={this.handleHideColumn}
                        getListForCommonFilter={this.getListForCommonFilter}
                        updateCommonFilter={this.updateCommonFilter}
                        commonFilter={this.state.params.list}
                        resetAllFilters={this.resetAllFilters}
                        resetAll={this.resetAll}
                        updateTableSortFilters={this.updateTableSortFilters}
                        resetSort={this.resetSort}
                        tableParams={this.state.params}
                        exportTableXl={this.exportTableXl}
                        tableLoading={this.state.tableLoading}
                        permissions={permissions}
                        isValueChanged={this.state.isValueChanged}
                        hasExport={checkPermission("forms", "documents", "export")}
                        showAddButton={checkPermission("forms", "documents", "create")}
                        hasEdit={checkPermission("forms", "documents", "edit")}
                        hasDelete={checkPermission("forms", "documents", "delete")}
                        hasInfoPage={checkPermission("forms", "documents", "view")}
                        entity="documents"
                        hasMasterFilter={path === "/documents"}
                        updateMasterFilters={this.updateMasterFilters}
                        masterFilters={masterFilters}
                        masterFilterList={masterFilterList}
                        getFilterLists={this.props.getMasterFilterLists}
                        status={this.state.status}
                        updateStatus={this.updateStatus}
                        showRestoreModal={this.showRestoreModal}
                        updateColumnWidthInConfig={this.updateColumnWidthInConfig}
                        resetAllTableConfig={this.resetAllTableConfig}
                        isTableResetting={this.state.isTableResetting}
                        searchField={this.state?.setSearchField}
                        setSearchField={() => {
                            this.setState({ setSearchField: null });
                        }}
                        setHighlightSearchField={this.state?.setHighlightSearchField}
                        hasGoToFunctionality={true}
                        tableRef={this.tableRef}
                        pinnedColumnsRef={this.pinnedColumnsRef}
                        handleColumnPin={this.handleColumnPin}
                        updateLastSortFilter={this?.updateLastSortFilter}
                    />
                )}
                {this.renderConfirmationModal()}
                {this.renderConfirmationModalLog()}
                {this.renderHardDeleteConfirmationModal()}
                {this.renderRestoreConfirmationModal()}
                {showViewModal ? (
                    <Portal
                        body={
                            <DynamicColumnModal
                                tableData={tableData}
                                handleHideColumn={this.handleHideColumn}
                                onCancel={() => this.setState({ showViewModal: false })}
                                handleGoToColumn={this.handleGoToColumn}
                            />
                        }
                        onCancel={() => this.setState({ showViewModal: false })}
                    />
                ) : null}
            </LoadingOverlay>
        );
    }
}
const mapStateToProps = state => {
    const { reportReducer } = state;
    return { reportReducer };
};

export default withRouter(
    connect(mapStateToProps, {
        ...actions
    })(Index)
);
